export const NOT_FOUND = 'Not found';
